<template>
  <div class="login">
    <div class="login_mask" v-if="!flagShow">
      <div style="width: 60%;height: 100%;margin: 10% auto;">
        <div style="width: 90%;height: 15%;margin: 1% auto;color: white;font-size: 20px;text-align: center;">
          傲举Ai后台管理平台
        </div>
        <el-form ref="form" :model="form" label-position="left" @submit.native.prevent>
          <el-form-item label="">
            <el-input style="" prefix-icon="el-icon-user
                    " v-model="form.auPhone" placeholder="请输入用户名"></el-input>
          </el-form-item>
          <div style="margin-top: 5%;">
            <el-form-item label="">
              <el-input style="" prefix-icon="el-icon-lock
                      " show-password v-model="form.auPw" placeholder="请输入密码"></el-input>
            </el-form-item>
          </div>

          <el-button type="primary" plain style="width: 100%;" @click="login">
            立即登录
          </el-button>
        </el-form>
      </div>
    </div>
  </div>
</template>

<script>

import { mapState, mapMutations, mapAction } from 'vuex'
import qs from "qs";
import {
  webUserLogin
} from "../api/api";
export default {
  name: 'doLogin',
  data() {
    return {
      flagShow: false,
      loginHeight: '',
      form: {
        auPhone: "",
        auPw: null,
      },
    }
  },
  mounted() {
    // 监听键盘事件
    window.addEventListener('keydown', this.keyDown)
  },
  destroyed() {
    window.removeEventListener('keydown', this.keyDown, false)
  },
  methods: {
    ...mapMutations(['changeuser']),
    keyDown(e) {
      //console.log(e)
      if (e.key == 'Enter') {
        this.login();
        e.preventDefault()//去掉默认的换行
      }
    },
    login() {
      if (this.form.auPhone == '' || this.form.auPw == '') {
        this.$message({
          showClose: true,
          message: '请输入用户名和密码',
          type: 'danger'
        });
      }
      // const s = qs.stringify(this.form)
      webUserLogin(this.form).then(res => {
        if (res.status == 200) {
          console.log('登录成功了', res.data)
          // this.$notify({
          //   title: '成功',
          //   message: '登录成功',
          //   type: 'success'
          // });
          this.changeuser({ aiAdmin: res.data })
          console.log('11');
          
            this.$router.push({
              path: '/Home'
            })
          } else {
            this.$notify.error({
              title: '错误',
              message: res.msg
            });
          }

  })
}
  },
created() {
  this.loginHeight = window.innerHeight
  document.title = '傲举Ai后台管理平台';
  this.flag = navigator.userAgent.match(/(phone|pad|pod|iPhone|iPod|ios|iPad|Android|Mobile|BlackBerry|IEMobile|MQQBrowser|JUC|Fennec|wOSBrowser|BrowserNG|WebOS|Symbian|Windows Phone)/i)
  if (this.flag) {
    this.flagShow = true;
  }
  if (localStorage.getItem('iuId')) {
    this.$router.push({
      path: '/Home'
    })
  }
},
mounted() {
  if (this.loginHeight < 800) {
    var oDiv = document.querySelector('.login_mask')
    oDiv.style.height = "55%";
    oDiv.style.width = "30%";


  }
},
activated() {


  document.title = '傲举Ai后台管理平台'

},
watch: {
  '$route'(to, from) {
    this.$router.go(0);
  }
},
}
</script>

<style scoped="scoped">
.login {
  width: 100vw;
  height: 100vh;
  overflow-x: hidden;
  overflow-y: hidden;
  background-image: url(../assets/login.jpg);
  background-position: inherit;
  background-repeat: no-repeat;
}

.login_mask {
  width: 25%;
  height: 40%;
  margin: 12% 0 0 65%;
  overflow: hidden;
  background-color: rgba(0, 0, 0, 0.3);
  box-shadow: 10px 0 10px 0 rgba(255, 255, 255, 0.1)
}

.login_mask2 {
  width: 100%;
  height: 60%;
  margin: 20% 0 0 0%;
  overflow: hidden;
  background-color: rgba(0, 0, 0, 0.3);
  box-shadow: 10px 0 10px 0 rgba(255, 255, 255, 0.1)
}
</style>
